import * as amplitude from "@amplitude/analytics-browser"
import { AnalyticsEventName, AnalyticsEvents } from "~/util/analyticsEvents"
import { isAmplitudeEnabled } from "~/util/amplitude"

declare global {
  interface Window {
    gtag: (...args: any[]) => void
  }
}

// Amplitude's autocapture already records a page view on every route change,
// so forwarding ours would double count them.
const AMPLITUDE_AUTOCAPTURED_EVENTS = ["page_view"]

export const trackEvent = <T extends AnalyticsEventName>(
  eventName: T,
  params: AnalyticsEvents[T]
) => {
  if (window.gtag) {
    window.gtag("event", eventName, params)
  }
  if (
    isAmplitudeEnabled() &&
    !AMPLITUDE_AUTOCAPTURED_EVENTS.includes(eventName)
  ) {
    amplitude.track(eventName, params)
  }
  console.debug("track", eventName, params)
}

// Amplitude batches events and sends them on a timer. A call site that leaves
// the page immediately (a Stripe redirect, a full page sign-in) must await this
// first, or the event is lost when the document unloads.
export const flushEvents = async () => {
  if (!isAmplitudeEnabled()) return
  try {
    await amplitude.flush().promise
  } catch (error) {
    console.error("failed to flush analytics events", error)
  }
}
